import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FormSection, Field } from "@/components/dossiers/FormSection";
import { TYPES_PROFESSIONNEL, labelClient } from "@/lib/dossiers";
import { cn } from "@/lib/utils";

export default function ClientSection({ clients, mode, setMode, client, setClient }) {
    const set = (k) => (v) => setClient((c) => ({ ...c, [k]: v }));

    return (
        <FormSection step={1} title="Client" description="Le donneur d'ordre du mandat (expert-comptable, avocat, dirigeant…)." testId="client-section">
            <div className="inline-flex rounded-full border border-border bg-card p-1 text-sm">
                {[
                    { v: "existing", l: "Client existant", disabled: clients.length === 0 },
                    { v: "new", l: "Nouveau client" },
                ].map((o) => (
                    <button
                        key={o.v}
                        type="button"
                        disabled={o.disabled}
                        data-testid={`client-mode-${o.v}`}
                        onClick={() => setMode(o.v)}
                        className={cn(
                            "px-4 py-1.5 rounded-full transition-colors disabled:opacity-40",
                            mode === o.v ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
                        )}
                    >
                        {o.l}
                    </button>
                ))}
            </div>

            {mode === "existing" ? (
                <Field id="client-select" label="Client" required>
                    <Select value={client.id} onValueChange={set("id")}>
                        <SelectTrigger id="client-select" data-testid="client-select" className="h-11 bg-card">
                            <SelectValue placeholder="Choisir un client…" />
                        </SelectTrigger>
                        <SelectContent>
                            {clients.map((c) => (
                                <SelectItem key={c.id} value={c.id} data-testid={`client-option-${c.id}`}>
                                    {labelClient(c)}
                                    {c.entreprises?.length > 1 ? ` (+${c.entreprises.length - 1} autre${c.entreprises.length > 2 ? "s" : ""})` : ""}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </Field>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <Field id="client-prenom" label="Prénom" required>
                        <Input id="client-prenom" data-testid="client-prenom-input" className="h-11 bg-card" value={client.prenom} onChange={(e) => set("prenom")(e.target.value)} />
                    </Field>
                    <Field id="client-nom" label="Nom" required>
                        <Input id="client-nom" data-testid="client-nom-input" className="h-11 bg-card" value={client.nom} onChange={(e) => set("nom")(e.target.value)} />
                    </Field>
                    <Field id="client-email" label="E-mail" required>
                        <Input id="client-email" type="email" data-testid="client-email-input" className="h-11 bg-card" value={client.email} onChange={(e) => set("email")(e.target.value)} />
                    </Field>
                    <Field id="client-type" label="Profession">
                        <Select value={client.type_professionnel} onValueChange={set("type_professionnel")}>
                            <SelectTrigger id="client-type" data-testid="client-type-select" className="h-11 bg-card">
                                <SelectValue placeholder="Sélectionner…" />
                            </SelectTrigger>
                            <SelectContent>
                                {TYPES_PROFESSIONNEL.map((t) => (
                                    <SelectItem key={t} value={t}>{t}</SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </Field>
                    <Field id="client-cabinet" label="Cabinet / société">
                        <Input id="client-cabinet" data-testid="client-cabinet-input" className="h-11 bg-card" value={client.nom_cabinet} onChange={(e) => set("nom_cabinet")(e.target.value)} />
                    </Field>
                </div>
            )}
        </FormSection>
    );
}
